import React from "react"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import OrganizationsPanel from "aldoo-ra/Organizations"

const OrganizationsSection = () => {
  const [auth] = PlatformAuth.useAuth()
  if (!auth) return null
  return <OrganizationsPanel currentUserId={auth._id} />
}

export default OrganizationsSection
